export default __webpack_public_path__ + "static/media/selfimg.c809cfcc.jpg";